import styled from 'styled-components/macro';


const ImageBackground = styled.div`
    width: 100%;
    height: 100%;
    
    background-image: url('${props => props.src}');
    background-size: ${props => props.imageFit || 'contain' };
    background-position: center;
    background-repeat: no-repeat;
`;


export default ImageBackground;


